/** Máscara de CNPJ: 00.000.000/0000-00 (só dígitos, até 14). */
export const maskCnpj = (raw: string) =>
  raw
    .replace(/\D/g, '')
    .slice(0, 14)
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2');

export const MASKS = { cnpj: { fn: maskCnpj, maxLength: 18, placeholder: '00.000.000/0000-00' } } as const;
export type MaskName = keyof typeof MASKS;
